import React, { Component } from 'react';
import styled from 'styled-components';

import Config from '../../../config';
import LocalStorage from '../../../utils/LocalStorageService';

class ErrorBoundary extends Component {
  static reloadPage = () => {
    LocalStorage.clearReduxLocalStorage();
    window.location.reload();
  };

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ErrorWrapper>
          <h1>{Config.TextStrings.errorOccurred}</h1>
          <p>{Config.TextStrings.reloadPage}</p>
          <Button onClick={ErrorBoundary.reloadPage}>
            {Config.TextStrings.backHome}
          </Button>
        </ErrorWrapper>
      );
    }
    return children;
  }
}
export default ErrorBoundary;

const ErrorWrapper = styled.div`
  display: flex;
  color: #ffffff;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Button = styled.button`
  padding: 5px;
  background-color: #40aec2;
  margin-top: 30px;
  text-decoration: none;
  color: #ffffff;
  border-radius: 4px;
  height: 50px;
  width: 280px;
  border: #40aec2 1px solid;
  font-size: 16px;
  &:hover {
    cursor: pointer;
  }
`;
